export const HIDDEN_FOLDERS_NOT_IGNORED = [
  '.contentlayer',
  '.svelte-kit',
  '.vitepress',
  '.nuxt',
  '.vscode',
  '.stackblitz',
  '.bolt',
];

// a regex that match .foobar in /home/project/.foobar/.env
const PARENT_DOT_FOLDERS_RE = /\/(\.[^\/]+)\//g;

interface FilePathInfo {
  fullPath: string;
  isDirectory: boolean;
}

export function isFilePathIgnored({ fullPath, isDirectory }: FilePathInfo) {
  const fileOrFolderName = fullPath.slice(fullPath.lastIndexOf('/') + 1);

  if (fileOrFolderName === 'node_modules' || fullPath.includes('/node_modules/')) {
    return true;
  }

  if (isDirectory && fileOrFolderName.startsWith('.') && !HIDDEN_FOLDERS_NOT_IGNORED.includes(fileOrFolderName)) {
    return true;
  }

  for (const [, dotFolderParentMatch] of fullPath.matchAll(PARENT_DOT_FOLDERS_RE)) {
    if (!HIDDEN_FOLDERS_NOT_IGNORED.includes(dotFolderParentMatch)) {
      return true;
    }
  }

  return false;
}
